__turbopack_context__.v({
  "appearAnimation": "_1BGm6W_appearAnimation",
  "replayBtn": "_1BGm6W_replayBtn",
  "root": "_1BGm6W_root",
  "videoContainer": "_1BGm6W_videoContainer",
});
